import { FleetConfig } from '@wix/thunderbolt-ssr-api'

export const shouldRouteStagingRequest = (fleetConfig: FleetConfig) => {
	return ['Stage', 'DeployPreview', 'Canary'].includes(fleetConfig.type)
}

export type Environment = 'client' | 'node' | 'ssrWorker' | 'clientWorker'
